import {ExtractArgs} from '@iiiristram/ts-type-utils'
import {Fetch, TypedRequestConfig} from '@logistics-frontend/core/utils/network'

import {StandardHeadersMode} from '../../api/corp'

function addHeaders<T extends TypedRequestConfig>(config: T, headers: T['headers']) {
  return {
    ...config,
    headers: {
      ...config.headers,
      // чтобы корректно послать CORS запрос config.meta?.standardHeadersMode должен быть disabled
      // скопипащенно с мидлвары в КК
      ...(config.meta?.standardHeadersMode !== StandardHeadersMode.Disable ? headers : {}),
    },
  }
}

export function addCorpHeaders<TRequestBody = unknown, TResponseBody = unknown, TTransformedBody = unknown>(
  fetch: Fetch<TRequestBody, TResponseBody, TTransformedBody>,
) {
  return (...[config]: ExtractArgs<typeof fetch>) => {
    const serverConfig = window.__CORP_CLIENT?.config
    const detectedCountry = serverConfig?.detectedCountry
    const locale = serverConfig?.countries?.[detectedCountry]?.localeSuffix
    const token = window.__CORP_CLIENT?.auth?.token
    const headers: Record<string, string> = {
      'X-Application-Version': serverConfig?.version,
      'Accept-Language': locale ? `${serverConfig?.lang}-${locale}` : serverConfig?.lang,
      'X-Requested-Uri': `${window.location.origin}${window.location.pathname}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '-1',
    }

    if (token) {
      headers['X-Csrf-Token'] = token
    }

    return fetch(addHeaders(config, headers))
  }
}
